import { useState } from 'react';
import { formatAmountNumber } from '../helpers';

export const useCurrencyInput = (initial = '', onChange) => {
  const [inputValue, setInputValue] = useState(initial);
  
  const cleanInputValue = (value) => {
    let clean = value.replace(/[^\d.,]/g, '');

    const firstCommaIndex = clean.indexOf(',');
    if (firstCommaIndex !== -1) {
      const before = clean.slice(0, firstCommaIndex + 1);
      const after = clean.slice(firstCommaIndex + 1).replace(/,/g, ''); // eliminar otras comas
      clean = before + after;
    }

    return clean;
  };

  const getValueToValidate = (value) => {
    if (!value) return 0;

    const numeric = value.replace(/\./g, '').replace(',', '.');
    const parsedValue = parseFloat(numeric);
    return isNaN(parsedValue) ? 0 : parsedValue;
  };

  const getDisplayValue = (value) => {
    
    if (!value) return '';
    const hasTrailingComma = value.endsWith(',');
    const cleanedNumeric = value.replace(/\./g, '').replace(',', '.');
    const parsedValue = !value.endsWith(',0')?parseFloat(cleanedNumeric):parseFloat(cleanedNumeric).toFixed(1);

    if (isNaN(parsedValue)) return value;

    const [intPart, decPart] = parsedValue.toString().split('.');
    const formattedInt = formatAmountNumber(parseInt(intPart));
    let result = formattedInt;
    
    if (hasTrailingComma) return `${result},`;
    if (decPart||decPart==='0') return `${result},${decPart}`;

    return result;
  };

  const handleChange = (e) => {
    let cleanedDisplayValue = cleanInputValue(e.target.value);
    setInputValue(cleanedDisplayValue);
    const numeric = getDisplayValue(cleanedDisplayValue);
    //Parseamos la respuesta a lo que devolvería un input nativo en su event.
    onChange({target:{name:e.target.name,value:getValueToValidate(numeric)}});
  };

  return {
    displayValue: getDisplayValue(inputValue),
    valueToValidate: getValueToValidate(inputValue),
    onChange: handleChange,
  };
};
